import React from "react";
import Container from "../Container";

export default ({ children, isFlex }) => (
  <div className="pv5">
    {isFlex ? (
      <div className="bg-white pa4 br2">{children}</div>
    ) : (
      <Container>
        <div className="bg-white pa4 br2">{children}</div>
      </Container>
    )}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/generic/layout/Body/index.js